// 請勿用這隻檔案做 Object.key || Object.key 相關的迴圈，避免測試專區也一起上線 
const FRONT_KEY = Object.freeze({
    // 首頁
    "C1X01" : "C1X01",
    "C1X02" : "C1X02",
    "C1X03" : "C1X03",
    "C1X04" : "C1X04",
    "C1X05" : "C1X05",
    // 會員管理
    "C2X01" : "C2X01",
    "C2X02" : "C2X02",
    "C2X03" : "C2X03",
    "C2X04" : "C2X04",
    "C2X05" : "C2X05",
    "C2X06" : "C2X06",
    "C2X07" : "C2X07",
    "C2X08" : "C2X08",
    "C2X09" : "C2X09",
    // 顧客管理
    "C3X01" : "C3X01",
    "C3X02" : "C3X02",
    "C3X03" : "C3X03",
    "C3X04" : "C3X04",
    "C3X05" : "C3X05",
    "C3X06" : "C3X06",
    "C3X07" : "C3X07",
    "C3X08" : "C3X08",
    "C3X09" : "C3X09",
    "C3X10" : "C3X10",
    "C3X11" : "C3X11",
    // 文書管理
    "C4X01" : "C4X01",
    "C4X02" : "C4X02",
    "C4X03" : "C4X03",
    "C4X04" : "C4X04",
    "C4X05" : "C4X05",
    "C4X06" : "C4X06",
    "C4X07" : "C4X07",
    "C4X08" : "C4X08",
    "C4X09" : "C4X09",
    "C4X10" : "C4X10",
    "C4X11" : "C4X11",
    "C4X12" : "C4X12",
    "C4X13" : "C4X13",
    // 營運報表
    "C5X01" : "C5X01",
    "C5X02" : "C5X02",
    "C5X03" : "C5X03",
    "C5X04" : "C5X04",
    "C5X05" : "C5X05",
    "C5X06" : "C5X06",
    "C5X07" : "C5X07",
    "C5X08" : "C5X08",
    // 營收管理
    "C6X01" : "C6X01",
    "C6X02" : "C6X02",
    "C6X03" : "C6X03",
    "C6X04" : "C6X04",
    "C6X05" : "C6X05",
    "C6X06" : "C6X06",
    "C6X07" : "C6X07",
    "C6X08" : "C6X08",
    "C6X09" : "C6X09",
    "C6X10" : "C6X10",
    "C6X11" : "C6X11",
    "C6X12" : "C6X12",
    "C6X13" : "C6X13",
    "C6X14" : "C6X14",
    "C6X15" : "C6X15",
    "C6X16" : "C6X16",
    "C6X17" : "C6X17",
    "C6X18" : "C6X18",
    "C6X19" : "C6X19",
    "C6X20" : "C6X20",
	"C6X21" : "C6X21",
    // 預約管理
    "C7X01" : "C7X01",
    "C7X02" : "C7X02",
    // 量身管理
    "C8X01" : "C8X01",
    "C8X02" : "C8X02",
    "C8X03" : "C8X03",
    "C8X04" : "C8X04",
    "C8X05" : "C8X05",
    "C8X06" : "C8X06",
    // 訊息管理
    "C9X01" : "C9X01",
    "C9X02" : "C9X02",
    "C9X03" : "C9X03",
    "C9X04" : "C9X04",
    // 店舖管理
    "C10X01": "C10X01",
    "C10X02": "C10X02",
    "C10X03": "C10X03",
    "C10X04": "C10X04",
    "C10X05": "C10X05",
    "C10X06": "C10X06",
    "C10X07": "C10X07",
    // 點數管理
    "C11X01": "C11X01",
    "C11X02": "C11X02",
    "C11X03": "C11X03",
    // POS結帳
    "C12X01": "C12X01",
    // 測試專用 只會出現在 dev 和 本地端
    "D999X01": "D999X01",
    "D999X02": "D999X02",
    "D999X03": "D999X03",
    "D999X04": "D999X04",
    "D999X05": "D999X05",
    "D999X06": "D999X06",
    "D999X07": "D999X07",
    "D999X08": "D999X08",
    "D999X09": "D999X09",
    "D999X10": "D999X10",
    "D999X11": "D999X11",
    "D999X12": "D999X12",
    "D999X13": "D999X13",
    "D999X14": "D999X14",
    // 店鋪庫存管理系統入口，須要對齊庫存管理系統的 frontKey
    INVENTORY: "D01X01",
});

export default FRONT_KEY;